import { render, staticRenderFns } from "./remove-from-comparison-button.vue?vue&type=template&id=1dec7439&lang=pug"
import script from "./remove-from-comparison-button.vue?vue&type=script&lang=coffee"
export * from "./remove-from-comparison-button.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports